import typeToReducer from "type-to-reducer";
import update from "immutability-helper";
import { GET_BETSLIP_CHECK_RESULTS, CLEAR_BETSLIP_CHECK_RESULTS, TOGGLE_BETSLIPDETAILS_MODAL } from "betSlipCheckActions.js";

let initialState = {
    events: [],
    isPending: false,
    error: null,
    isBetSlipDetailsOpen: false,
};

export default typeToReducer(
    {
        [GET_BETSLIP_CHECK_RESULTS]: {
            PENDING: state => {
                return { ...state, error: null, isPending: true };
            },
            SUCCESS: (state, { payload: { data } }) => {
                const newState = update(state, { events: { $set: data }, isPending: { $set: false } });
                return { ...newState };
            },
            FAILURE: (state, { payload: { error } }) => {
                return { ...state, isPending: false, error };
            }
        },
        [CLEAR_BETSLIP_CHECK_RESULTS]: (state) => {
            return { ...state, events: [], error: null }
        },
        [TOGGLE_BETSLIPDETAILS_MODAL]: (state, { payload: { isBetSlipDetailsOpen } }) => {
            return { ...state, isBetSlipDetailsOpen };
        },
    },
    initialState
);
